<template lang="">
    <div class="wrap_footer">
        <div class="footer_con">
            <div class="join_us">
                <div class="tit_area">
                    <h3 class="tit">快捷导航</h3>
                    <i class="icon icon_arrow"></i>
                </div>
                <ul class="join_list">
                    <li v-for="(item,index) in list1">
                        <a @click="goRouter(item.url)">{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="join_us">
                <div class="tit_area">
                    <h3 class="tit">主营产品</h3>
                    <i class="icon icon_arrow"></i>
                </div>
                <ul class="join_list">
                    <li v-for="(item,index) in config.product">
                        <a @click="goDetail(item.id)">{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="join_us">
                <div class="tit_area">
                    <h3 class="tit">联系我们</h3>
                    <i class="icon icon_arrow"></i>
                </div>
                <ul class="join_list">
                    <li v-for="(item,index) in list3">
                        <a v-html="item.name"></a>
                    </li>
                </ul>
            </div>
            <div class="join_us logo_tencent">
                <div class="fo_logo">
                    <img :src="config.qrcode" alt="Tencent腾讯">
                    <div class="zxc">关注微信</div>
                </div>
            </div>
        </div>
        <div class="footer_area">
            <p class="copyright">Copyright © 2019 - {{now}} All Rights Reserved. <br class="flag_m">鹏成化工 版权所有<a href="http://beian.miit.gov.cn/" class="flag_num">蜀ICP备19039373号</a></p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            now:new Date().getFullYear(),
            config,
            list1:[
                // {name:"首页",url:"/"},
                {name:"产品展示",url:"/product"},
                {name:"公司简介",url:"/about"},
                {name:"新闻动态",url:"/news"},
                {name:"合作企业",url:"/partner"},
                {name:"联系我们",url:"/contact"},
            ],
            list3:[
                {name:`联系人：${config.contact.name}`},
                {name:`电话：${config.contact.tel}`},
                {name:`QQ：${config.contact.QQ}`},
                {name:`邮箱：${config.contact.email}`},
                {name:`地址：${config.contact.address}`},
            ]
        }
    },
    methods:{
        goRouter(url){
            this.$router.push(url);
        },
        goDetail(id){
            this.$router.push(`/detail/${id}`);
        }
    }
}
</script>

<style lang="less" scoped>
    .wrap_footer{
        padding-top: 30px;
        max-width: 1200px;
        margin: 0 auto;
        .footer_con{
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 30px;
            .join_us{
                flex: 1;
                min-width: 200px;
                ul,li{
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                li{
                    cursor: pointer;
                    a, a:hover, a:active, a:visited, a:link, a:focus {
                        -webkit-tap-highlight-color: rgba(0,0,0,0);
                        -webkit-tap-highlight-color: transparent;
                        outline: none;
                        background: none;
                        text-decoration: none;
                        display: block;
                        font-size: 16px;
                        color: #5f6464;
                        font-weight: normal;
                        margin-bottom: 18px;
                    }
                    a{
                        word-break: break-all;
                    }
                }
                h3{
                    font-size: 20px;
                    color: #5f6464;
                    margin-bottom: 30px;
                }
            }
        }
        .logo_tencent{
            text-align: right;
            img{
                margin-top: 20px;
                width: 200px;
                max-width: 200px;
                margin-bottom: 20px;
            }
        }
        .footer_area{
            text-align: center;
        }
        .fo_logo{
            display: inline-block;
            text-align: center;
        }
    }
    @media only screen and (max-width: 1200px){
        .wrap_footer{
            .join_us{
                padding: 0 20px;
            }
            .logo_tencent{
                text-align: center;
                img{
                    width: 100%;
                }
            }
        }
    }
    
</style>